module.exports = __webpack_public_path__ + "static/img/0547_1.a3d76e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0547_1.jpg
// module id = N6t8
// module chunks = 1